var sanrenfukuOddsTable = {
  template: `
    <div class="clearfix">
      <div class="fl-left pr5 w25per" v-for="(row1, syaban1, index) in voteInfo.entries">
        <table class="mb30 w100per table table-vote-number">
          <tr><th :colspan="Object.keys(voteInfo.entries).length + 1" :class="'bg-lighten-' + syaban1">
            {{ syaban1 }}
            {{ voteInfo.entries[ syaban1 ].name }}
          </th></tr>
          <tr class="text-center">
            <th :class="'bg-lighten-' + syaban1"></th>
            <td class="p0">
              <table class="w100per" v-for="(row2, syaban2, index) in voteInfo.entries" v-show="syaban2 > syaban1 && index + 1 < Object.keys(voteInfo.entries).length">
                <th class="text-center" colspan="2" :class="'bg-lighten-' + syaban2">
                  {{ syaban2 }}
                  {{ voteInfo.entries[ syaban2 ].name }}
                </th>
                <tr class="text-center">
                  <th :class="'bg-lighten-' + syaban2"></th>
                  <td class="p0">
                    <table class="w100per" >
                      <tr class="text-center" v-for="(col, syaban3) in voteInfo.entries" v-show="voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ]">
                        <th :class="'bg-lighten-' + syaban3">{{ syaban3 }}</th>
                        <td class="p0">
                          <a class="block" v-if="voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ]" @click.prevent="addOddsTableItems(voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ], syaban1 + '-' + syaban2 + '-' + syaban3)" :class="{'is-absent': !voteInfo.oddsTableData[syaban1 + '-' + syaban2 + '-' + syaban3].is_valid}">
                            {{ voteInfo.oddsTableData[ syaban1 + '-' + syaban2 + '-' + syaban3 ].normalize_rate }}
                          </a>
                        </td>
                      </tr>
                    </table>
                  </td>
                </tr>
              </table>
            </td>
          </tr>
        </table>
      </div>
    </div>
  `
};

export default {
  sanrenfukuOddsTable
}